import PropTypes from 'prop-types';
import React from 'react';
import NotificationMethods from '../../../../common/notificationMethods';
import LockNotice from './LockNotice';
import OptOutEngagement from './OptOutEngagement';

const Notifications = ({
  disabled,
  optOutEngagement,
  initialValues,
}) => (
  <div className="u-mt u-ml">
    <fieldset disabled={disabled}>
      <LockNotice display-if={disabled} />
      <NotificationMethods customer />
    </fieldset>
    <OptOutEngagement
      display-if={initialValues.id}
      onClick={optOutEngagement}
      customer={initialValues}
    />
  </div>
);

Notifications.propTypes = {
  disabled: PropTypes.bool,
  optOutEngagement: PropTypes.func,
  initialValues: PropTypes.object,
};

Notifications.defaultProps = {
  disabled: false,
  optOutEngagement: () => {},
  initialValues: {},
};

export default Notifications;
